const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const makeAuthenticatedRequest = async (url, options = {}) => {
  const token = localStorage.getItem('access_token');
  if (!token) throw new Error('No authentication token found');
  return fetch(url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
      ...options.headers,
    },
  });
};

export const priceNegotiationsApi = {
  // Get the full price trail for a deal or enquiry
  getPrices: async ({ dealId, enquiryId }) => {
    const params = new URLSearchParams();
    if (dealId) params.append('deal_id', dealId);
    if (enquiryId) params.append('enquiry_id', enquiryId);
    const response = await makeAuthenticatedRequest(
      `${API_BASE_URL}/api/v1/price-negotiations/?${params.toString()}`,
      { method: 'GET' }
    );
    if (!response.ok) throw new Error(`Failed to fetch prices: ${response.status}`);
    return await response.json();
  },

  // Log a new price step (does NOT overwrite previous prices)
  logPrice: async (payload) => {
    const response = await makeAuthenticatedRequest(
      `${API_BASE_URL}/api/v1/price-negotiations/`,
      { method: 'POST', body: JSON.stringify(payload) }
    );
    if (!response.ok) throw new Error(`Failed to log price: ${response.status}`);
    return await response.json();
  },
};
